/**
 * Tour Configurations Index
 * 
 * Centralized export for all tour configurations.
 * Each tour is in its own file for better organization.
 */

import { getDashboardTourSteps } from './dashboardTour';
import { getDisbursementsTourSteps } from './disbursementsTour';
import { getSingleDisbursementTourSteps } from './disbursementsSingleTour';
import { getBulkDisbursementTourSteps } from './disbursementsBulkTour';
import { getCollectionsTourSteps } from './collectionsTour';
import { getInvoicingTourSteps } from './invoicingTour';
import { getPayrollTourSteps } from './payrollTour';
import { getReportsTourSteps } from './reportsTour';
import { getSMSTourSteps } from './smsTour';
import { getUtilitiesTourSteps } from './utilitiesTour';
import { getSettlementsTourSteps } from './settlementsTour';
import { getCheckoutTourSteps } from './checkoutTour';
import {
  getSettingsTourSteps,
  getSettingsProfileTourSteps,
  getSettingsPaymentMethodsTourSteps,
  getSettingsSecurityTourSteps,
  getSettingsVerificationTourSteps,
  getSettingsBusinessTourSteps,
  getSettingsAPITourSteps,
  getSettingsTeamTourSteps
} from './settingsTour';

// Export a function that returns steps for any tour ID
export const getTourSteps = (tourId, t) => {
  const tourStepMap = {
    'dashboard-tour': getDashboardTourSteps(t),
    'disbursements-tour': getDisbursementsTourSteps(t), // Legacy - keeps old behavior
    'disbursements-single-tour': getSingleDisbursementTourSteps(t),
    'disbursements-bulk-tour': getBulkDisbursementTourSteps(t),
    'collections-tour': getCollectionsTourSteps(t),
    'checkout-tour': getCheckoutTourSteps(t),
    'invoicing-tour': getInvoicingTourSteps(t),
    'payroll-tour': getPayrollTourSteps(t),
    'reports-tour': getReportsTourSteps(t),
    'sms-tour': getSMSTourSteps(t),
    'utilities-tour': getUtilitiesTourSteps(t),
    'settlements-tour': getSettlementsTourSteps(t),
    'settings-tour': getSettingsTourSteps(t),
    'settings-profile-tour': getSettingsProfileTourSteps(t),
    'settings-payment-methods-tour': getSettingsPaymentMethodsTourSteps(t),
    'settings-security-tour': getSettingsSecurityTourSteps(t),
    'settings-verification-tour': getSettingsVerificationTourSteps(t),
    'settings-business-tour': getSettingsBusinessTourSteps(t),
    'settings-api-tour': getSettingsAPITourSteps(t),
    'settings-team-tour': getSettingsTeamTourSteps(t),
  };

  return tourStepMap[tourId] || [];
};

